import { render, staticRenderFns } from "./PaymentTimesDepositedRule.vue?vue&type=template&id=5bed3f8a&"
import script from "./PaymentTimesDepositedRule.vue?vue&type=script&lang=js&"
export * from "./PaymentTimesDepositedRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports